/* eslint-disable camelcase */
import { DurationInputArg1, DurationInputArg2 } from 'moment-timezone';

export interface UserPrime {
  userID: number;
  appID: number;
  startedOn: Date | string | undefined;
  expires: string | undefined;
  status: number;
  mobile: number;
  wikiLinks: number;
  timeline: number;
  recs: number;
  paid: number;
  B2B: number;
  recurly: number;
  examDate: string | null;
}

export type PrimeDetails = Omit<UserPrime, 'userID' | 'appID' | 'examDate'> & {
  userID?: UserPrime['userID'];
  appID?: UserPrime['appID'];
  examDate?: UserPrime['examDate'];
  expired: boolean;
  paused?: boolean;
  isAutoRenew?: boolean;
  monthly: number;
  canceled: number;
  status?: number;
  prime_status?: string;
};

export interface UserPrimeData {
  userID: UserPrime['userID'][];
  appID: UserPrime['appID'][];
  startedOn: UserPrime['startedOn'][];
  expires: UserPrime['expires'][];
  status: UserPrime['status'][];
  mobile: UserPrime['mobile'][];
  wikiLinks: UserPrime['wikiLinks'][];
  timeline: UserPrime['timeline'][];
  recs: UserPrime['recs'][];
  paid: UserPrime['paid'][];
  B2B: UserPrime['B2B'][];
  recurly: UserPrime['recurly'][];
  examDate: UserPrime['examDate'][];
}

export type StubUserPrime = Pick<
  UserPrime,
  'status' | 'mobile' | 'wikiLinks' | 'timeline' | 'recs'
>;

export interface Prime {
  app: number;
  amount: DurationInputArg1;
  unit: DurationInputArg2;
  currentTermEndsAt?: Date;
  plan?: Record<string, unknown>;
  product?: string;
  type?: number;
  trial?: boolean;
}

export type PrimeWith2WeekMinimum = Pick<
  UserPrime,
  'userID' | 'expires' | 'status' | 'B2B'
> & {
  minPrimeExpiration: string;
  joinDate: string;
};

export const primeStatusToString = (status?: number): string => {
  if (!status) return 'none';
  if (status == 1) return 'paid';
  if (status == 2) return 'trial';
  if (status == -1) return 'expired';
  return 'none';
};
